<script lang="ts" setup>
import type { IProps } from './solutions-imageWithTextAndBoxes.types'
import SolutionsUiBoxSimple from '@/domains/solutions/solutions-UiBoxSimple/solutions-UiBoxSimple.vue'

withDefaults(defineProps<IProps>(), {
  color: 'white',
})
</script>

<template>
  <section
    :class="[
      'image-with-text-boxes',
      `image-with-text-boxes--${color}`
    ]"
  >
    <div class="image-with-text-boxes__wrapper">
      <UiHeader
        :header="header"
        position="left"
      />
      <div class="image-with-text-boxes__layout">
        <img
          class="image-with-text-boxes__image"
          :src="image"
        >

        <div class="image-with-text-boxes__content">
          <div
            class="image-with-text-boxes__text"
            v-html="text"
          />

          <div class="image-with-text-boxes__boxes">
            <SolutionsUiBoxSimple
              v-for="box in boxes"
              :key="box.title"
              :box="box"
            />
          </div>

          <UiButton
            v-if="button"
            :to="button.to"
          >
            {{ button.text }}
          </UiButton>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.image-with-text-boxes {
  width: 100%;
  padding: 4rem 2.4rem;

  &__wrapper {
    max-width: 115.2rem;
    width: 100%;
    margin: 0 auto;

    @include atXL {
      max-width: 134rem;
    }
  }

  @include atM {
    padding: 12rem 2.4rem;
  }

  &--purple {
    background-color: $purple-50;
  }

  &__layout {

    width: 100%;
    margin-top: 3.2rem;

    @include atM {
      display: flex;
      gap: 9.7rem;
      margin-top: 5.6rem;
    }
  }

  &__image {
    display: block;
    max-width: 80%;
    margin: 0 auto;
  }

  &__content {
    display: flex;
    flex-direction: column;

    .button {
      align-self: center;

      @include atM {
        align-self: flex-start;
      }
    }
  }

  &__text {
    margin-top: 3.2rem;
    font-weight: 500;
    font-size: 2rem;
    line-height: 2.8rem;

    :deep() {
      b,
      strong {
        padding-bottom: 0.4rem;
        border-bottom: 0.16rem solid $purple-400;
      }
    }

    @include atM {
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }

  &__boxes {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin-top: 3rem;
    margin-bottom: 3.2rem;

    @include atXS {
      flex-direction: row;
      flex-wrap: wrap;
      gap: 1.6rem;
      margin-top: 4.4rem;
      margin-bottom: 6.4rem;

      .box {
        width: calc(50% - 0.8rem);
      }
    }
    
  }
}
</style>
